import { render, staticRenderFns } from "./InlandFreight.vue?vue&type=template&id=5adbd554&scoped=true"
import script from "./InlandFreight.vue?vue&type=script&lang=js"
export * from "./InlandFreight.vue?vue&type=script&lang=js"
import style0 from "./InlandFreight.vue?vue&type=style&index=0&id=5adbd554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adbd554",
  null
  
)

export default component.exports